import Vue from 'vue';
import App from './App';
import router from './router/router.js';
import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css';
import './assets/css/comm.scss';
import './assets/css/rem.js';
import store from './store/index';
import echarts from 'echarts';
import axios from 'axios';
import Vtip from 'vtip';
import VueQriously from 'vue-qriously';
import 'vtip/lib/index.min.css';
import './mixins/share';
import './utils/wxsdk';
import GoBackHome from '@/components/basic/GoHome';
Vue.component('go-back-home', GoBackHome);

// import './utils/eruda'
// 二维码生成插件
Vue.use(VueQriously);

import clipper from './utils/clipper';
Vue.use(clipper);

//复制用
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// 注册指令使用
Vue.use(Vtip.directive);
// 工具函数调用
Vue.prototype.$tip = Vtip.tip;

Vue.prototype.$echarts = echarts;

Vue.use(MintUI);
Vue.config.productionTip = false;
Vue.config.devtools = true;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js